/* eslint-disable */
"use strict";

import { QFUtil } from "./../../components/util.js";
import QFLayoutContent from "./content.js";

var KTLayoutStretchedCard = function() {
    // Private properties
	var _element;

	// Private functions
	var _init = function() {
		var scroll = QFUtil.find(_element, '.card-scroll');
		var cardBody = QFUtil.find(_element, '.card-body');
		var cardHeader = QFUtil.find(_element, '.card-header');

		var height = QFLayoutContent.getHeight();

		height = height - parseInt(QFUtil.actualHeight(cardHeader));

		height = height - parseInt(QFUtil.css(_element, 'marginTop')) - parseInt(QFUtil.css(_element, 'marginBottom'));
		height = height - parseInt(QFUtil.css(_element, 'paddingTop')) - parseInt(QFUtil.css(_element, 'paddingBottom'));

		height = height - parseInt(QFUtil.css(cardBody, 'paddingTop')) - parseInt(QFUtil.css(cardBody, 'paddingBottom'));
		height = height - parseInt(QFUtil.css(cardBody, 'marginTop')) - parseInt(QFUtil.css(cardBody, 'marginBottom'));

		height = height - 3;

		QFUtil.css(scroll, 'height', height + 'px');
	}

    // Public methods
	return {
		init: function(id) {
            _element = QFUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
			_init();

            // Re-calculate on window resize
            QFUtil.addResizeHandler(function() {
				_init();
			});
		},

		update: function() {
			_init();
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = KTLayoutStretchedCard;
}

export default KTLayoutStretchedCard;